import auditApi from "@/services/api/audit";

const state = {
  entries: [],
  isLoading: false,
  whaleEntries: [],
  whaleLoading: false,
};

const getters = {
  entries: (state) => state.entries,
  loading: (state) => state.isLoading,
  whaleEntries: (state) => state.whaleEntries,
  whaleLoading: (state) => state.whaleLoading,
};

const actions = {
  async loadEntries({ commit }, filters = {}) {
    commit("loading", true);
    const result = await auditApi.list({
      entityType: filters.entityType || null,
      entityLabel: filters.entityLabel || null,
      limit: filters.limit !== undefined ? filters.limit : 200,
    });
    commit("setEntries", result.data || []);
    commit("loading", false);
  },
  async loadWhaleHistory({ commit }, whaleId) {
    commit("whaleLoading", true);
    const result = await auditApi.list({
      entityType: "whale",
      entityLabel: whaleId,
      limit: -1,
    });
    commit("setWhaleEntries", result.data || []);
    commit("whaleLoading", false);
  },
};

const mutations = {
  setEntries(state, entries) {
    state.entries = entries;
  },
  loading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setWhaleEntries(state, entries) {
    state.whaleEntries = entries;
  },
  whaleLoading(state, isLoading) {
    state.whaleLoading = isLoading;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
